/* eslint-disable i18next/no-literal-string */
/* eslint-disable react-hooks/exhaustive-deps */
import { Divider, List, Typography, Alert } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { LayoutGrid, LayoutGridItem } from 'app/layout/LayoutGrid';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { DocumentDropzone } from 'app/components/Common/DocumentDropzone/DocumentDropzone';
import { DocumentDragDropAttachments } from './DocumentDragDropAttachments';
import { ExceptionWaiveAttachment } from '../models/PlacementDialogModels';
import { placementEventActions } from '../../../../Store/PlacementEventDetails.redux';
import {
  ExceptionWaiveSelection,
  ExceptionWaveNewAttachmentSelection,
} from '../../../../Store/PlacementEventDetails.selector';
import { globalActions } from 'app/ApplicationRoot/Global.redux';
import { selectUser } from 'oidc/user.selectors';
import { getAttachmentName, randomNumber } from './DocumentDragDropHelper';
import { deleteExceptionWaiveAttachment } from 'app/services/CredentialingServices/CredentialingServices';
const mime = require('mime-types');

const useStyles: any = makeStyles()(theme => ({
  divider: {
    margin: '10px 0px 10px 0px',
    height: 2,
  },
  uploader: {
    width: 200,
  },
  listItem: {
    border: '1px solid #ECECEC',
    margin: '0px 0px 8px 0px',
    padding: '10px',
    borderRadius: '5px',
  },
  btnAdjustment: {
    paddingRight: '15px',
  },
  updateDetails: {
    paddingRight: '15px',
  },
  docIcon: {
    paddingRight: '5px',
  },
  fileNameActions: {
    marginBottom: '10px',
  },
  listRoot: {
    maxHeight: '260px',
    overflowY: 'auto',
    width: '100%',
    height: '100%',
    padding: `0px`,
  },
}));

export const DocumentDragDropWrapper = props => {
  const { classes } = useStyles();
  const newAttachmentData = useSelector(ExceptionWaveNewAttachmentSelection);
  const exceptionWaiveSel = useSelector(ExceptionWaiveSelection);
  const [newAttachments, setNewAttachments] = useState<any>([]);
  const [existingAttachments, setExistingAttachments] = useState<any>([]);
  const [errorSize] = useState<any>(null);
  const [errorLimit] = useState<any>(null);
  const user = useSelector(selectUser);
  const dispatch = useDispatch();

  useEffect(() => {
    setNewAttachments(newAttachmentData || []);
  }, [newAttachmentData]);

  const existingFileCheck = fileName => {
    const currentAttachment = [...existingAttachments, ...newAttachments];
    var fileCheck = false;
    if (currentAttachment?.length > 0) {
      const existingAttachment = currentAttachment?.filter(fileAttachment =>
        fileAttachment.name == null || fileAttachment.name === ''
          ? getAttachmentName(fileAttachment?.data) === fileName
          : fileAttachment?.name === fileName,
      );
      if (existingAttachment?.length !== 0) {
        fileCheck = true;
      }
    }
    return fileCheck;
  };

  useEffect(() => {
    if (exceptionWaiveSel) {
      const tempAttachments: any[] = [];
      exceptionWaiveSel?.existingAttachments?.map((item, idx) => {
        const temp = {
          data: item.attachmentUrl,
          name: item.title,
          status: 'default',
          title: item.title,
          type: item.attachmentType,
          id: item?.id,
        };
        tempAttachments.push(temp);
      });
      setExistingAttachments(tempAttachments);
    }
  }, [exceptionWaiveSel]);

  //Drop zone Attachments.
  const documentUploadFailFunc = fileRejections => {
    let files = '';
    let errorFiles = '';
    const fileCount = newAttachments?.length + existingAttachments?.length;
    fileRejections.forEach(fileItems => {
      const errorCode = fileItems?.errors[0]?.code || '';
      switch (errorCode) {
        case 'file-too-large':
          errorFiles = errorFiles + '' + fileItems.file.name + ',';
          break;
        case 'file-invalid-type':
          if (fileItems.file.name.split('.').pop() === 'msg' && fileCount <= 4) {
            const attachment = {
              name: fileItems?.file?.name,
              type: fileItems?.fileExt,
              data: fileItems?.file,
              status: 'default',
              title: '',
              id: 10 + randomNumber(99),
            };
            if (!existingFileCheck(fileItems?.file?.name)) {
              dispatch(placementEventActions.appendExceptionWaveNewAttachment(attachment));
            } else {
              dispatch(
                globalActions.setSnackBar({
                  message: `"${_.trimEnd(fileItems.file.name, ',')}" file already exists`,
                  severity: 'error',
                }),
              );
            }
          } else if (fileCount > 4) {
            dispatch(
              globalActions.setSnackBar({
                message: `"${_.trimEnd(
                  fileItems.file.name,
                  ',',
                )}" files failed to attach, because it exceeds the 4 attachment limit`,
                severity: 'error',
              }),
            );
          } else files = files + '' + fileItems.file.name + ',';
          break;
      }
    });
    if (!!files) {
      dispatch(
        globalActions.setSnackBar({
          message: `"${_.trimEnd(
            files,
            ',',
          )}" files failed to attach, because valid file types: jpg, jpeg, png, docx, xls, pdf, csv, Outlook email`,
          severity: 'error',
        }),
      );
    }

    if (!!errorFiles) {
      dispatch(
        globalActions.setSnackBar({
          message: `"${_.trimEnd(
            errorFiles,
            ',',
          )}" files failed to attach, because it exceeds the 5MB attachment limit`,
          severity: 'error',
        }),
      );
    }
  };

  const documentUploadFunc = acceptedFiles => {
    props.isChanged('attachments', null);
    let fileCount = newAttachments?.length + existingAttachments?.length;
    let files = '';
    acceptedFiles.forEach(file => {
      var fileExt = file.name.split('.').pop();
      fileCount += 1;
      if (fileCount <= 4) {
        const attachment = {
          name: file.name,
          type: fileExt,
          data: file,
          status: 'default',
          title: '',
          id: 10 + randomNumber(99),
        };
        if (!existingFileCheck(file?.name)) {
          dispatch(placementEventActions.appendExceptionWaveNewAttachment(attachment));
        } else {
          dispatch(
            globalActions.setSnackBar({
              message: `"${_.trimEnd(file?.name, ',')}" file already exists`,
              severity: 'error',
            }),
          );
        }
      } else files = files + '' + file.name + ',';
    });

    if (fileCount > 4) {
      dispatch(
        globalActions.setSnackBar({
          message: `"${_.trimEnd(files, ',')}" files failed to attach, because it exceeds the 4 attachment limit`,
          severity: 'error',
        }),
      );
    }
  };

  //Handle Logic For Delete/Edit Attachments
  const onAttachmentTitleEdit = (e, id) => {
    if (
      exceptionWaiveSel?.existingAttachments &&
      exceptionWaiveSel?.existingAttachments?.length > 0 &&
      parseInt(id) - 1 <= exceptionWaiveSel?.existingAttachments?.length - 1
    ) {
      let updatedAttachments = _.cloneDeep(exceptionWaiveSel?.existingAttachments);

      updatedAttachments = updatedAttachments?.map((item, index) => {
        if (index === parseInt(id) - 1) {
          return { ...item, title: e?.target?.value };
        }
        return item;
      });
      dispatch(
        placementEventActions.setExceptionWaive({
          ...exceptionWaiveSel,
          existingAttachments: updatedAttachments || exceptionWaiveSel?.existingAttachments,
        }),
      );
      setExistingAttachments(updatedAttachments || exceptionWaiveSel?.existingAttachments);
    } else {
      let updatedAttachments = _.cloneDeep(newAttachments);

      updatedAttachments = updatedAttachments?.map((item, index) => {
        if (index + (exceptionWaiveSel?.existingAttachments?.length || 0) === parseInt(id) - 1) {
          return { ...item, title: e?.target?.value };
        }
        return item;
      });
      dispatch(placementEventActions.setExceptionWaveNewAttachment(updatedAttachments));
      setNewAttachments(updatedAttachments);
    }
  };

  const onAttachmentDelete = id => {
    if (exceptionWaiveSel?.existingAttachments && exceptionWaiveSel?.existingAttachments.length > 0 && id >= 1000) {
      let updatedAttachments: any[] = _.cloneDeep(exceptionWaiveSel?.existingAttachments);
      const deletedAttachment = updatedAttachments.find((item, index) => item.id === parseInt(id));
      if (deletedAttachment) {
        updatedAttachments = updatedAttachments.filter((item, index) => item.id !== parseInt(id));
        dispatch(placementEventActions.appendDeletedAttachments(deletedAttachment));
        dispatch(
          placementEventActions.setExceptionWaive({
            ...exceptionWaiveSel,
            existingAttachments: updatedAttachments || exceptionWaiveSel?.existingAttachments,
          }),
        );
        setExistingAttachments(updatedAttachments || exceptionWaiveSel?.existingAttachments);
        deleteAttachmentItem(deletedAttachment);
      }
    } else {
      const filteredAttachments = newAttachments.filter((item, index) => item.id !== parseInt(id));
      setNewAttachments(filteredAttachments);
      dispatch(placementEventActions.setExceptionWaveNewAttachment(filteredAttachments));
    }
  };

  const deleteAttachmentItem = async (deletedAttachment: ExceptionWaiveAttachment) => {
    if (deletedAttachment) {
      const exceptionWaiveAttachment = {
        exceptionWaiveId: deletedAttachment?.exceptionWaiveId,
        attachmentUrl: deletedAttachment.attachmentUrl,
        currentEmployeeId: user.userInfo?.employeeId || 0,
        currentEmployeeName: `${user.userInfo?.firstName} ${user.userInfo?.lastName}`,
      };
      dispatch(placementEventActions.setNotify(true));
      await deleteExceptionWaiveAttachment(exceptionWaiveAttachment).then(response => {
        dispatch(
          globalActions.setSnackBar({
            message: 'Deleting Attachment...',
            severity: 'info',
          }),
        );
        if (response && response.status === 200) {
          dispatch(
            globalActions.setSnackBar({
              message: 'Attachment deleted successfully',
              severity: 'success',
            }),
          );
        } else {
          dispatch(
            globalActions.setSnackBar({
              message: 'There was an error deleting attachments. Please try again',
              severity: 'error',
            }),
          );
        }
      });
    }
  };

  const AlertMessage = props => {
    return (
      <>
        <LayoutGridItem item xs={12}>
          <Alert severity="error">
            <Typography component="span" variant="body2">
              {props.message}
            </Typography>
          </Alert>
        </LayoutGridItem>
      </>
    );
  };

  return (
    <>
      <Divider variant="middle" className={classes.divider} />
      <LayoutGrid container>
        <LayoutGridItem item xs={4}>
          <LayoutGrid container>
            <LayoutGridItem item xs style={{ paddingBottom: '10px' }}>
              <Typography component="span" variant="body2">
                Add Attachments
              </Typography>
            </LayoutGridItem>
          </LayoutGrid>
          <DocumentDropzone
            disabled={props.disableUpload}
            onDrop={acceptedFiles => documentUploadFunc(acceptedFiles)}
            onDropRejected={fileRejections => documentUploadFailFunc(fileRejections)}
            // @ts-ignore
            accept={
              'image/jpeg, image/png, image/jpg,application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel, application/vnd.ms-outlook'
            }
          />
        </LayoutGridItem>
        <LayoutGridItem item xs={8}>
          <List classes={{ root: classes.listRoot }}>
            {[...existingAttachments, ...newAttachments]?.map((value: any, index) =>
              React.cloneElement(
                <DocumentDragDropAttachments
                  itemNumber={value?.id}
                  docName={value?.id < 1000 ? value?.name : getAttachmentName(value?.data)}
                  docType={mime.lookup(value?.type || 'application/unknown')}
                  docID={(index + 1).toString()}
                  docEdit={true}
                  item={value}
                  submitFailedAttachment={props.submitFailedAttachment}
                  onAttachmentTitleEdit={onAttachmentTitleEdit}
                  onAttachmentDelete={onAttachmentDelete}
                  status={value?.status}
                  canDelete={true}
                  editTitle={value?.id >= 1000 ? false : true}
                  documentTitle={value?.id < 100 ? null : value?.name}
                />,
                {
                  key: index,
                },
              ),
            )}
          </List>
        </LayoutGridItem>
      </LayoutGrid>
      <LayoutGrid container>
        {errorSize && <AlertMessage message={errorSize} />}
        {errorLimit && <AlertMessage message={errorLimit} />}
      </LayoutGrid>
    </>
  );
};
